import { render, staticRenderFns } from "./AppSkeleton.vue?vue&type=template&id=469354e7&scoped=true"
var script = {}
import style0 from "./AppSkeleton.vue?vue&type=style&index=0&id=469354e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469354e7",
  null
  
)

export default component.exports